import { Component, ViewChild } from '@angular/core';
import {
  breadcrumb,
  link,
  stat,
} from 'src/app/admin/layout/header/header.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import icons from '../../../../misc/data/icons.json';
import { SelectItem, TreeNode } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { Message } from 'primeng/api';
import {
  ConfirmationService,
  MessageService,
  ConfirmEventType,
} from 'primeng/api';
import { MultiSelectQuestion } from 'src/app/misc/component/dynamic-form/question-multiselect';
import { CheckBoxQuestion } from 'src/app/misc/component/dynamic-form/question-checkbox';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { TreeSelectQuestion } from 'src/app/misc/component/dynamic-form/question-treeselect';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

import { TranslatorPipe } from 'src/app/services/translator.pipe';



@Component({
  selector: 'app-data-templates',
  templateUrl: './data-templates.component.html',
  styleUrls: ['./data-templates.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class DataTemplatesComponent {
  skelition = true;

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;

  messages: Message[] = [];
  translator: TranslatorPipe = new TranslatorPipe()

  header = this.translate('data templates');
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-arrow-left',
      link: '/admin/data',
      visible: this.permissionService.hasPermission('DATA', 'r'),
    },
    {
      name: this.translate('Data classification'),
      icon: 'pi pi-file',
      link: '/admin/data/fields',
      visible: this.linkPermissions('DATA_FIELD'),
    },
    {
      name: this.translate('Types of classifications'),
      icon: 'pi pi-file-edit',
      link: '/admin/data/fields/types',
      visible: this.linkPermissions('DATA_FIELD_TYPE'),
    },
    {
      name: this.translate('data types'),
      icon: 'pi pi-list',
      link: '/admin/data/types',
      visible: this.linkPermissions('DATA_TYPE')
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('data'), link: '/admin/data' },
    { name: this.translate('Add data'), link: '/admin/data/add' },
    { name: this.translate('Organize data templates'), link: '/admin/data/templates' },
  ];

  stats: stat[] = [];

  templatesData: any[] = [];

  data: any[] = [];
  dataType: any = [];
  fields: any = [];
  iconOptions: SelectItem[] = [];
  questions: QuestionBase<string>[] = [];

  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;

  //select Ou Variables
  selectOuModal: boolean = false;
  selectedOU: any;
  treeDDData: TreeNode[] = [];
  staticURL = GlobalConstants.staticFilesURL;

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private orgUnits: OrgUnitsService,
    public permissionService: PermissionHandlerService
  ) { }

  linkPermissions(flag: string) {
    return this.permissionService.hasAnyPermission([{ unit: flag, flag: 'c' }, { unit: flag, flag: 'u' }, { unit: flag, flag: 'd' }]);
  }

  ngOnInit() {
    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });

    Promise.all([
      this.getTemplatesData(),
      this.fetchDataType(),
      this.fetchFields(),
      this.fetchDataType(),
      this.getTreeData(),
    ]).then((e) => {
      this.makequestion();
      this.skelition = false;
    });
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  async getTreeData() {
    this.treeDDData = await this.orgUnits.getOrgUnits();
  }

  getTemplatesData = async () => {
    try {
      let res = await this.dataService.postData('data-template/get/', {});

      console.log("Data Templates 0000", res)

      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.templatesData = res.data;
      this.templatesData.forEach((item: any) => {
        let fields = item.fields.map((e: any) => e.name).join(' ,');
        this.data.push({
          '#': { n: item._id, i: 'pi pi-angle-left' },
          'اسم القالب': { n: item.name, i: item.icon },
          التصنيف: { n: fields },
          'نوع البيانات': { n: item.type.arabic, i: item.type.icon },
          النوع: { n: item.standard ? 'أساسي' : item.ou ? item?.ou?.name : 'الجهات المشاركة' },
          الحالة: {
            n: item.active,
            i: item.active ? 'pi pi-check-circle' : 'pi pi-times-circle',
          },
          Action: [
            {
              n: 'Delete',
              i: 'pi pi-times',
              s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ],
        });
      });
      this.updateTypeCounts();
      console.log('data ou catagory => ', this.templatesData, this.data);
    } catch (error) {
      console.log(error);
    }
  };

  private async fetchDataType(): Promise<void> {
    let res = await this.dataService.postData('data-type/get', {
      active: true,
    });
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.dataType = res.data.map((item: any) => {
      return {
        _id: item._id,
        label: item.arabic,
        icon: `pi pi-${item.icon}`,
        value: item._id,
      };
    });
  }

  private async fetchFields(): Promise<void> {
    let res = await this.dataService.postData('data-fields/get', {
      active: true,
    });
    console.log('FIELDS', res.data);
    if (res.error) {
      return;
    }
    this.fields = res.data;
    this.fields = this.fields.map((e: any) => ({ ...e, name: `${e.name} (${e.priority})` }))

    console.log('NEW FIE', this.fields);
  }

  makequestion() {
    this.questions = [

      new CheckBoxQuestion({
        key: 'standard',
        label: 'أساسي',
        order: 6,
        icon: 'pi pi-building',
        className: 'col-6 col-sm-12 col-12',
        value: this.backupDate ? this.backupDate?.standard : true,
        // value: this.updateData?.isManager || false,
      }),

      new TextboxQuestion({
        key: 'name',
        label: 'اسم القالب',
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'type',
        label: 'نوع البيانات',
        required: true,
        options: this.dataType,
        filter: true,
        order: 3,
        className: 'col-md-12 col-sm-12 col-12',
        value : this.backupDate ?? this.backupDate?.type
      }),

      new MultiSelectQuestion({
        key: 'fields',
        label: 'التصنيف',
        required: true,
        options: this.fields,
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
        value : this.backupDate ?? this.backupDate?.fields
      }),

      

      new TreeSelectQuestion({
        key: 'ou',
        label: 'الصنف الأب',
        treeOptions: this.treeDDData,
        order: 6,
        icon: 'pi pi-file',
        filter: true,
        className: 'col-6 col-sm-12 col-12',
        visibility:   this.backupDate?.standard == false ? "true" : "false",
      }),

      new DropdownQuestion({
        key: 'active',
        label: 'الحالة',
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
        value: true,
        visibility: 'false',
      }),
    ];
  }


  backupDate : any = undefined

  checkBoxChanged(event:any){
    this.backupDate = event
    this.makequestion()

   //debugger
  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;
      let newData = data;

      // if(newData.standard && th){
      //   this.selectOuModal =true
      // }

      newData.fields = data.fields.map((obj: any) => obj._id);
      newData.type = data.type;
      let treedata: any;
      if (newData.standard) {
        newData.ou = null;
      } else {
        treedata = newData?.ou;
        console.log('==>Send Ou', treedata, newData?.ou);
        newData.ou = newData?.ou?._id;
      }
      console.log('===>newData', newData);

      let res = await this.dataService.postData('data-template/', newData);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.DynamicFormComponent.resetForm();
      window.location.reload();
      data.fields = this.fields.filter((e: any) =>
        data.fields.some((u: any) => u == e._id)
      );
      let fields = data.fields.map((e: any) => e.name).join(' ,');
      let type = this.dataType.find((e: any) => e._id == data.type);

      console.log('===>Data.ou==>', data.ou);

      data.type = type;
      data._id = res.data._id;
      console.log(data);
      this.templatesData.push(data);
      this.data.unshift({
        '#': { n: res.data.data._id, i: 'pi pi-angle-left' },
        'اسم القالب': { n: data.name, i: data.icon },
        الحالة: {
          n: data.active,
          i: data.active ? 'pi pi-check-circle' : 'pi pi-times-circle',
        },
        التصنيف: { n: fields },
        'نوع البيانات': { n: type.label, i: type.icon },
        النوع: { n: data.standard ? 'Standard' : treedata?.label },
        Action: [
          {
            n: 'Delete',
            i: 'pi pi-times',
            s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
          },
          {
            n: 'Update',
            i: 'pi pi-file-edit',
            s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          },
        ],
      });
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  UpdateData = async ($event: any) => {
    try {
      let data: any = $event;
      data._id = this.updateData._id;

      let treedata: any;
      if (data.standard) {
        data.ou = null;
      } else {
        treedata = data?.ou;
        console.log('==>Send Ou', treedata, data?.ou);
        data.ou = data?.ou?._id;
      }

      let res = await this.dataService.postData(
        'data-template/',
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      data.type = this.dataType.find((e: any) => e._id == data.type);
      data.ou = treedata;
      // updating in table
      const myObject = this.data.find((item) => item['#'].n === data._id);
      if (myObject) {
        (myObject['اسم القالب'].n = data.name),
          (myObject['اسم القالب'].i = data.icon);
        myObject['النوع'].n = data.standard ? 'Standard' : treedata?.label;
        myObject['الحالة'].n = data.active;
        myObject['الحالة'].i = data.active
          ? 'pi pi-check-circle'
          : 'pi pi-times-circle';
        myObject['التصنيف'].n = data.fields.map((e: any) => e.name).join(' ,');
        myObject['نوع البيانات'].n = data.type.label;
        myObject['نوع البيانات'].i = data.type.icon;
      }

      this.data.map((e, i) => {
        if (e['#'].n === data._id) {
          this.data[i] = myObject;
          return;
        }
      });

      this.templatesData.map((e, i) => {
        if (e._id === data._id) {
          this.templatesData[i] = data;
          return;
        }
      });
      console.log(this.templatesData);
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  actionCall($event?: any) {
    console.log('==> Action Call recieved=', $event);
    let action = !!$event?.action  ? $event.action : 'Update'
    action
   //debugger
    switch (action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Confirmation message'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteCatagory($event.id),
        });
        break;
      case 'Update':
        if(!!$event?.action){
        this.updateData = this.templatesData.find(
          (item) => item._id == $event.id
        );
        this.updateData.fields = this.fields.filter((e: any) =>
          this.updateData.fields.some((u: any) => u._id == e._id)
        );
      }

        console.log('UPDATE', this.updateData);

        if (!this.updateData.standard && this.updateData.ou != null) {
          if (!this.updateData?.ou?.label) {
            this.updateData.ou.label = this.updateData?.ou?.name;
          }
          if (!this.updateData?.ou?.value) {

            this.updateData.ou.value = this.updateData?.ou?._id;
          }
        }

        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: 'اسم القالب',
            required: true,
            order: 1,
            icon: 'pi pi-file',
            className: 'col-md-12 col-sm-12 col-12',
            value: this.updateData?.name,
          }),

          new DropdownQuestion({
            key: 'type',
            label: 'نوع البيانات',
            required: true,
            options: this.dataType,
            filter: true,
            order: 3,
            className: 'col-md-12 col-sm-12 col-12',
            value: this.updateData?.type._id,
          }),

          new MultiSelectQuestion({
            key: 'fields',
            label: 'التصنيف',
            required: true,
            options: this.fields,
            order: 4,
            className: 'col-md-12 col-sm-12 col-12',
            value: this.updateData.fields,
          }),

          new CheckBoxQuestion({
            key: 'standard',
            label: 'أساسي',
            order: 5,
            icon: 'pi pi-building',
            className: 'col-6 col-sm-12 col-12',
            value: this.updateData?.standard || false,
          }),

          new TreeSelectQuestion({
            key: 'ou',
            label: 'الصنف الأب',
            treeOptions: this.treeDDData,
            order: 2,
            filter: true,
            icon: 'pi pi-file',
            value: this.updateData?.ou || '',
            className: 'col-12',
            visibility: this.updateData?.standard == false ? 'true' : 'false',
          }),

          new DropdownQuestion(<any>{
            key: 'active',
            label: 'الحالة',
            required: true,
            options: [
              { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
              { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
            ],
            order: 6,
            className: 'col-md-12 col-sm-12 col-12',
            value: this.updateData.active,
          }),
        ];
        console.log('Update Data ==>', this.templatesData, this.updateData);
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }

  updateCheckBoxChanged(event:any){
   //debugger
    this.updateData.standard = event.standard
    if(this.updateData.standard){
      this.updateData.ou = undefined
    }
    this.actionCall()
  }

  deleteCatagory = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`data-template/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.data = this.data.filter((item) => item['#'].n !== id);
      this.templatesData = this.templatesData.filter((item) => item._id === id);
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  private updateTypeCounts(): void {
    let activeCount = this.templatesData.filter(
      (e) => e.active === true
    ).length;
    let inactiveCount = this.templatesData.length - activeCount;
    this.stats = [
      { name: this.translate('active'), number: activeCount, icon: 'pi pi-check-circle' },
      { name: this.translate('Inactive'), number: inactiveCount, icon: 'pi pi-times-circle' },
    ];
  }
}
